
<div class="container-fluid" *ngIf="!isFromStockReco">
    <div class="row" *ngIf="!isFromStockReco">
        <div class="col-md-12 col-12 col-sm-12" style="margin:15px 0px 5px; display: inherit;">
            <div class="col-md-8 col-sm-8 col-xs-8" style="display: inline-block; padding-left: 0px;">
                <h4 style="display: inline-block;font-size: 24px;">Batch Details</h4>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4" style="display: inline-block; text-align: right; padding: 0px;">
                <span *ngIf="batchSelectionData.mode != 'Out'" class="label brdrRadius3" (click)="openBatchMdl(batchMdl,0)" title="Add New Batch"
                style="position: relative; top: 0px; cursor: pointer; bottom: 5px; padding: 8px 10px !important; font-size: 11px; background:#e88421 !important; color:#fff !important; margin-right: 5px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 16px; vertical-align: middle;TOP: -1PX;
                position: relative;"></i>
                </span>
                <span>
                    <i class="closeMdl zmdi zmdi-close" style="top: -7px; padding:6px 10px !important" (click)="closeModal()"></i>
                </span>
            </div>
        </div>
    
        <!-- Batch Table -->
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px;overflow-y: auto; max-height: 60vh;" *ngIf="batchList.length > 0">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th style="width: 29%;">Batch</th>
                        <th style="width: 22%; text-align: right;" *ngIf="isCQShow && batchSelectionData.mode == 'Out'">Batch Qty</th>	
                        <th style="width: 25%; text-align: right;">Qty</th>
                        <th style="width: 24%;" *ngIf="hasExpiry">Expiry</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i of batchList;">
                        <td style="padding-top: 12px !important;">{{i.B}}</td>
                        <!-- <td style="text-align: right;">{{i.qty}}</td> -->
                        <td style="text-align: right;vertical-align: inherit;" *ngIf="i.CQ && batchSelectionData.mode == 'Out'">	
                            {{i.CQ}}	
                        </td>	
                        <td style="text-align: right;">
                            <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px;">
                                <input tabindex="1" class="txtRight form-control" style="width: 55px; display: inline; padding: 4px 4px 0px;" 
                                    (keyup)="prcisionCheck(i)"  (change)="prcnQty(i)" [(ngModel)]="i.Q" maxlength="20" numbers_only >{{qtySKU}} </div>
                            </td>
                        <td *ngIf="hasExpiry" style="padding-top: 15px !important;">{{i.E | todayTommorow}}</td>                    
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="showOldBatches && oldBatchList.length > 0" class="col-md-12 col-sm-12 col-xs-12 " style="padding-top: 10px">	
            <div  class="lableBtnOrange inLneBlk" style="border-radius: 30px; cursor: pointer; font-size: 13px; margin-bottom: 20px;" (click)="openOldBatchesMdl(oldBatchMdl, 0)">	
                Show Old Batches 	
            </div>	
        </div>
        <!-- Save -->
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px 15px; font-size: 12px;" *ngIf="batchList.length > 0">
            <span class="btn-green brdrRadius3" style="padding: 2px 8px;" (click)="fn_SaveBatches()" >
                <i class="fa fa-check" style="margin-right: 5px;"></i> Save
            </span>
        </div>
    
        <div (click)="openBatchMdl(batchMdl,0)" *ngIf="batchList.length == 0" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 5px 0px 15px 15px;">
            <div class="nrf brdrRadius3" style="cursor: pointer;">Click here to add batches.</div>
        </div>
        <!-- <div (click)="batchSelectionData.mode != 'Out' ? openBatchMdl(batchMdl,0) : ''" *ngIf="batchList.length == 0" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 5px 0px 15px 15px;">
            <div class="nrf" style="cursor: pointer;">{{batchSelectionData.mode != 'Out' ? ' Click here to add batches.' : 'No data found.'}}</div>
        </div> -->
    </div>
</div>



<!-- reconsilation -->
<div *ngIf="isFromStockReco" class="col-md-12 col-sm-12 col-xs-12 batchDiv" style="padding: 10px 5px 0px 10px;padding-top: 10px;">
    <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px;">
        <div style="color:#15304A; display: inline-block;">Batches</div>
        <div style="display: inline-block; float: right;">
            <span *ngIf="showOldBatches && oldBatchList.length > 0" class="darkBlueBadge brdrRadius3" style="padding: 2px 15px; margin-right:8px; line-height: 28px; cursor: pointer; font-size: 13px;" (click)="openOldBatchesMdl(oldBatchMdl, 0)">	
                Show Old Batches 	
            </span>	
             <span *ngIf="batchSelectionData.mode != 'Out'" class="lableBtnOrange brdrRadius3" (click)="openBatchMdl(batchMdl,0)" title="Add a New Batch"
            style="position: relative; top: 0px; cursor: pointer; line-height: 18px !important; bottom: 5px; padding: 6px 10px !important; font-size: 11px; margin-right: 5px;">
            <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 14px; vertical-align: middle;
            position: relative;"></i>
            </span>
        </div>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12" style="padding:0px; height: 305px; overflow-y: auto; overflow-x: hidden; padding-top: 0px;">
        <div  *ngFor="let s of batchList; let s = index;"class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-bottom: 10px;">
            <div class="col-md-4 col-sm-4 col-4" style="display: inline-block; padding: 0px; font-size: 14px;">
            {{s.B}}
            </div>
            <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px; text-align: right; font-size: 14px;">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="display: inline-block; padding:0px; margin-right: 10px;">
                    <div class="{{hasExpiry ? 'col-md-5 col-sm-5 col-xs-5' : 'col-md-12 col-sm-12 col-xs-12' }} pad0" style="padding: 0px; display: inline-block;padding-right: 5px;width:{{hasExpiry ? '50%' : '100%'}};  ">
                    <input tabindex="1" class="txtRight form-control" style="width: 55px; display: inline; background: inherit; padding: 4px 4px 0px;" 
                        (keyup)="prcisionCheck(s)"  (change)="prcnQty(s)" [(ngModel)]="s.Q" maxlength="20" numbers_only >{{qtySKU}} 
                    </div>
                    <div class="col-md-7 col-sm-7 col-xs-7 pad0" *ngIf="hasExpiry" style=" display: inline-block; padding-right: 5px !important; padding: 0px; padding-top: 15px !important; width:{{hasExpiry ? '40%' : ''}};">{{s.E | todayTommorow}}</div>
                </div>
            </div>
        </div>
        <div (click)="openBatchMdl(batchMdl,0)" *ngIf="batchList.length == 0" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 10px 0px 15px 0px">
            <div class="nrf" style="cursor: pointer; padding: 8px 15px;">Click here to add batches.</div>
        </div>
    </div>
</div>



<!--Add BATCH MODAL-->
<ng-template #batchMdl let-modal>
    <div class="modal-header" style="border-bottom: none;padding-top: 10px;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Add Batch</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right; padding: 7px 10px !important;position: relative;top: -4px !important;" 
                    (click)="closeEntryMdl()" data-dismiss="modal"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px 10px 15px;">
            <div class="col-md-12 col-sm-12 col-xs-12" style="padding:0px">
                <div class="col-md-8 col-xs-12 col-sm-12" style="padding: 0px 5px 0px 5px;display: inline-block;">
                    <input type="text" [(ngModel)]="objBatchEntry.batchName" class="form-control" maxlength="50" style="text-indent: 2px;font-size: 13px;"
                    placeholder="Enter Batch Name">
                    <mat-form-field class="example-full-width top14 wdt font13" style="width: 100%; display: none" mat-form-field-should-float: false>
                        <mat-label readonly>Batch Name</mat-label>
                        <input matInput [(ngModel)]="objBatchEntry.batchName" tabindex="1"
                            captalize-first maxlength="100">
                    </mat-form-field>
                </div>
                
                <div class="col-md-4 col-xs-12 col-sm-12 mdlexptxtBox" *ngIf="hasExpiry">
                    <input  matInput readonly [matDatepicker]="picker1" (focus)="picker.open()" class="form-control mdlexptxtBox" [(ngModel)]="objBatchEntry.expiryDT" tabindex="1"
                            style="display: inline-block; background: #FFF; font-size: 12px; " placeholder="Expiry Date">
                        <mat-datepicker-toggle matSuffix [for]="picker1"
                            style="display: inline-block; position: relative; height: 30px;"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                </div>
            </div>
            <div class="col-md-12 col-xs-12 col-12" style="display: inline-block;padding: 0px;top: 15px; margin-bottom: 20px;">
                <span class="btn-green brdrRadius3" style="padding:  2px 8px;line-height: 23px;font-size: 13px;"
                    (click)="addNewBatch()">
                    <i class="fa fa-check" style="margin-right: 5px;"></i>
                    <span>Save</span>
                </span>
            </div>
        </div>
    </div>
</ng-template>


<!--Select Old Batches -->	
<ng-template #oldBatchMdl let-modal>	
    <div class="modal-header" style="border-bottom: none; padding-top: 10px;">	
        <div class="col-md-12 col-12 col-xs-12">	
            <div class="row">	
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">	
                    <h4 class="modal-title">	
                        <span id="ApntmntHdr">Select Old Batch </span>	
                    </h4>	
                </div>	
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">	
                    <i class="closeMdl zmdi zmdi-close" style="float: right; padding: 7px 10px !important;position: relative;top: -4px !important;" 	
                    (click)="closeOldBatchesMdl()" data-dismiss="modal"></i>	
                </div>	
            </div>	
        </div>	
    </div>	
    <!--Body-->	
    <div class="modal-body" style="padding: 0px;">	
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px 10px 15px;">	
            <div class="col-md-12 col-sm-12 col-xs-12" style="padding:0px">	
                <div class="col-md-12 col-xs-12 col-12" style="padding: 0px 5px 0px 5px;display: inline-block;">	
                    <span>	
                        <mat-form-field class="example-full-width font13" style="width: 95%; display: none">	
                            <mat-label>Qty</mat-label>	
                            <input matInput tabindex="1" class="txtRight">	
                        </mat-form-field>	
                        <mat-form-field class="example-full-width font13" style="width: 95%; margin-right: 5px;">	
                            <input matInput placeholder="Select Batch" autofocus="false"	
                                [(ngModel)]="old.batchName" [matAutocomplete]="auto">	
                            <mat-autocomplete #auto="matAutocomplete">	
                                <mat-option *ngFor="let i of oldBatchList" [value]="i.B">	
                                    <span>{{i.B}} </span>	
                                </mat-option>	
                            </mat-autocomplete>	
                        </mat-form-field>	
                    </span>	
                </div>	
            </div>	

            <div class="col-md-12 col-xs-12 col-12" style="display: inline-block;padding: 0px;top: 15px; margin-bottom: 20px;">	
                <span class="btn-green brdrRadius3" style="padding: 2px 8px; line-height: 23px; font-size: 13px;"	
                    (click)="saveOldBatch()">	
                    <i class="fa fa-check" style="margin-right: 5px;"></i>	
                    <span>Select</span>	
                </span>	
            </div>	
        </div>	
    </div>	
</ng-template>	
